export default __webpack_public_path__ + "static/media/polygon-logo.0d9fa38b.png";